/*
 *** 公共方法,请不要在这里写特例或者业务代码
 */
import api from '@/api/api';
import locale from './locale';
export default {
    mixins: [locale],
    beforeCreate () {
        this.$Loading.config({
            color: '#fbe5d1',
            failedColor: '#f0ad4e',
            height: 2
        });
    },
    data() {
        return {
            userInfoList: this.$store.state.userInfoList, // 用户信息列表
            formValidate: {
                country: []
            },
            mask: false,
            tagIdList: [],
            shippingMethodModel: [],
            shippingMethodData: [],
            shippingAccountModel: [],
            carrierAccount: [], // 对应物流账号
            tagsList: [],
            roleList: this.$store.state.roleList,
            controlList: this.setControlList(),
            storeFilterMes: '',
            autoWidth: 0,
            domWidth: document.documentElement.clientWidth || document.body.clientWidth || 0,
            domHeight: document.documentElement.clientHeight || document.body.clientHeight || 0,
            twoItemMd: {
                span: 11
            },
            twoItemLg: {
                span: 11
            },
            threeItemLg: {
                span: 7
            },
            threeItemMd: {
                span: 7
            },
            oneItemMd: {
                span: 12
            },
            oneItemLg: {
                span: 7
            },
            pageArray: [10, 20, 50, 100],
            placeholderSrc: './static/images/placeholder.jpg',
            spinShow: false
        };
    },
    watch: {
        roleList(n, o) {
            if (n !== o) {
                this.controlList = this.setControlList();
            }
        }
    },
    methods: {
        getTableHeight(curHeight) {
            let v = this;
            return v.domHeight - curHeight < 400 ? 400 : v.domHeight - curHeight;
        },
        reloadTag(val) { // 标签更新
            let v = this;
            v.orderData.forEach((n, i) => {
                if (n.orderId === v.orderDetailsId) {
                    v.orderData[i].orderTagList = val;
                }
            });
        },
        loadingFalse() { // 重置table loading状态
            this.$nextTick(function() {
                this.loading = false;
            });
        },
        setControlList() {
            let storeRoleList = this.$store.state.roleList;
            return storeRoleList;
        },
        resetSpinShow() {
            this.spinShow = false;
        },
        spinLoading() {
            this.spinShow = true;
        },
        getOrderListTag() { // 获取标签列表
            let v = this;
            v.axios.get(api.get_orderListTag + '?type=1')
                .then(response => {
                    if (response.data.code === 0) {
                        let data = response.data.datas;
                        v.$nextTick(function() {
                            v.tagsList = data;
                        });
                    }
                });
        },
        getCountrys() {
            let v = this;
            if (localStorage.getItem('area') === undefined || localStorage.getItem('area') === []) {
                localStorage.removeItem('area');
            }
            if (localStorage.getItem('area') !== 'null' && localStorage.getItem('area')) {
                v.formValidate.country = JSON.parse(localStorage.getItem('area'));
            } else {
                v.axios.get(api.get_countrys)
                    .then(response => {
                        if (response.data.code === 0) {
                            let data = response.data.datas;
                            v.formValidate.country = data;
                            localStorage.setItem('area', JSON.stringify(data));
                        }
                    });
            }
        },
        countryChange(value) { // 高级筛选国家列表获取
            let v = this;
            if (value.indexOf('null') >= 0) {
                v.pageParams.buyerCountryCodeList = null;
            } else {
                v.pageParams.buyerCountryCodeList = value;
            }
        },
        getDefaultTimezoom() { // 获取默认时区
            if (localStorage.getItem('timezoom') !== undefined && localStorage.getItem('timezoom') !== null) {
                return false;
            }
            let v = this;
            let localtime = new Date().getTime();
            let universalTime = new Date(v.getUniversalTime(new Date().getTime(), 'fulltime')).getTime();
            let timezoom = parseInt((localtime - universalTime) / 60 / 60 / 1000);
            timezoom >= 0 ? timezoom = '+' + timezoom : timezoom = '-' + timezoom;
            localStorage.setItem('timezoom', timezoom);
            return timezoom;
        },
        getNowTime() { // 获取用户设置的时间
            let timezoom = localStorage.getItem('timezoom');
            if (timezoom !== undefined) {
                let diffTime = Number(timezoom) * 60 * 60 * 1000;
                return new Date().getTime() - diffTime;
            } else {
                return new Date().getTime();
            }
        },
        getDateTime(date, type) { // 时间格式获取
            let d = new Date(date);
            let year = d.getFullYear();
            let month = d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1;
            let day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate();
            let hours = d.getHours() < 10 ? '0' + d.getHours() : d.getHours();
            let minutes = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes();
            let seconds = d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds();
            if (type === 'fulltime') {
                return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
            } else {
                return year + '-' + month + '-' + day;
            }
        },
        getUniversalTime(date, type) { // UTC时间
            if (date === null) return;
            let d = new Date(date);
            let year = d.getUTCFullYear();
            let month = d.getUTCMonth() + 1 < 10 ? '0' + (d.getUTCMonth() + 1) : d.getUTCMonth() + 1;
            let day = d.getUTCDate() < 10 ? '0' + d.getUTCDate() : d.getUTCDate();
            let hours = d.getUTCHours() < 10 ? '0' + d.getUTCHours() : d.getUTCHours();
            let minutes = d.getUTCMinutes() < 10 ? '0' + d.getUTCMinutes() : d.getUTCMinutes();
            let seconds = d.getUTCSeconds() < 10 ? '0' + d.getUTCSeconds() : d.getUTCSeconds();
            if (type === 'fulltime') {
                return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
            } else {
                return year + '-' + month + '-' + day;
            }
        },
        getDataToLocalTime(date, type) { // 本地时间
            if (date === null) return null;
            let b = new Date(date).getTime() + localStorage.getItem('timezoom') * 60 * 60 * 1000;
            let d = new Date(b);
            let year = d.getFullYear();
            let month = d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1;
            let day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate();
            let hours = d.getHours() < 10 ? '0' + d.getHours() : d.getHours();
            let minutes = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes();
            let seconds = d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds();
            if (type === 'fulltime') {
                return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
            } else {
                return year + '-' + month + '-' + day;
            }
        },
        getRemainTime(date) { // 剩余时间
            let v = this;
            if (date === null) return null;
            let remainTime = new Date(v.getDataToLocalTime(date, 'fulltime')).getTime() / 1000;
            let nowDate = v.getNowTime() / 1000;
            return v.getLimitTime(remainTime - nowDate);
        },
        toogleContentDisplay(status, cname) { // 箭头状态，是否显示的div
            let v = this;
            if (v[status] === 'chevron-up') {
                v[status] = 'chevron-down';
                v[cname] = false;
            } else {
                v[status] = 'chevron-up';
                v[cname] = true;
            }
        },
        hideLayer(cname) {
            let v = this;
            v[cname] = true;
        },
        validateEmail() { // 邮箱格式校验，可共用
            const reg = /^(\w)+(\.\w+)*@(\w)+((\.\w{2,3}){1,3})$/;
            let validateEmail = function(rule, value, callback) {
                if (value === '') {
                    callback(new Error('请输入邮箱地址'));
                } else if (!reg.test(value)) {
                    callback(new Error('邮箱格式不正确'));
                } else {
                    callback();
                }
            };
            return validateEmail;
        },
        validateEmpty() {
            let validateEmpty = function(rule, value, callback) {
                if (value === '' || value === null) {
                    callback(new Error('内容不能为空'));
                } else {
                    callback();
                }
            };
            return validateEmpty;
        },
        validateMobile() { // 手机校验，可共用
            let isPhone = /^([0-9]{3,4}-)?[0-9]{7,8}$/;
            let isMob = /^((\+?86)|(\(\+86\)))?(13[012356789][0-9]{8}|15[012356789][0-9]{8}|18[02356789][0-9]{8}|147[0-9]{8}|1349[0-9]{7})$/;
            let validateMobile = function(rule, value, callback) {
                if ((!isPhone.test(value) && !isMob.test(value)) && value !== '') {
                    callback(new Error('电话号码格式不正确'));
                } else {
                    callback();
                }
            };
            return validateMobile;
        },
        typeOf(obj) {
            let toString = Object.prototype.toString;
            let map = {
                '[object Boolean]': 'boolean',
                '[object Number]': 'number',
                '[object String]': 'string',
                '[object Function]': 'function',
                '[object Array]': 'array',
                '[object Date]': 'date',
                '[object RegExp]': 'regExp',
                '[object Undefined]': 'undefined',
                '[object Null]': 'null',
                '[object Object]': 'object'
            };
            return map[toString.call(obj)];
        },
        deepCopy(data) {
            let v = this;
            let t = v.typeOf(data);
            let o;
            if (t === 'array') {
                o = [];
            } else if (t === 'object') {
                o = {};
            } else {
                return data;
            }
            if (t === 'array') {
                for (let i = 0; i < data.length; i++) {
                    o.push(v.deepCopy(data[i]));
                }
            } else if (t === 'object') {
                for (let i in data) {
                    o[i] = v.deepCopy(data[i]);
                }
            }
            return o;
        },
        shallowCopy(src) {
            let dst = {};
            for (let prop in src) {
                if (src.hasOwnProperty(prop)) {
                    dst[prop] = src[prop];
                }
            }
            return dst;
        },
        getShippingList(h) {
            let v = this;
            v.axios.get(api.get_enableCarriers)
                .then(response => {
                    if (response.data.code === 0) {
                        let data = response.data.datas;
                        let pos = [];
                        for (let i = 0; i < data.length; i++) {
                            pos.push({
                                value: data[i].carrierId,
                                label: data[i].carrierName,
                                children: [],
                                loading: false,
                                carrierAccounts: data[i].carrierAccounts
                            });
                            if (i === data.length - 1) {
                                v.shippingMethodData = pos;
                            }
                        }
                    } else {
                        v.$Message.error(v.t('common.sysErrorMes'));
                    }
                });
        },
        loadData(item, callback) {
            item.loading = true;
            let v = this;
            v.axios.get(api.get_enableShippingMethods + '?carrierId=' + item.value)
                .then(response => {
                    if (response.data.code === 0) {
                        let data = response.data.datas;
                        let pos = [];
                        for (let i = 0; i < data.length; i++) {
                            pos.push({
                                value: [data[i].shippingMethodId, item.carrierAccounts],
                                label: data[i].carrierShippingMethodName
                            });
                            if (i === data.length - 1) {
                                item.children = pos;
                                item.loading = false;
                                callback();
                            }
                        }
                        if (data.length === 0) {
                            item.children = pos;
                            item.loading = false;
                            v.$Message.warning(v.t('common.emptyResult'));
                            callback();
                        }
                    } else {
                        item.loading = false;
                        item.children = [];
                        v.$Message.error(v.t('common.sysErrorMes'));
                    }
                })
                .catch(() => {
                    item.loading = false;
                    item.children = [];
                    v.$Message.error(v.t('common.sysErrorMes'));
                });
        },
        getAccount(value, selectedData) {
            let v = this;
            v.carrierAccount = [];
            if (value.length === 0) return false;
            v.shippingMethodModel = [];
            v.shippingAccountModel = [];
            v.getCarrierBaseSetting(value[1][0]);
            if (value[1][1] !== null) {
                v.carrierAccount = value[1][1];
            }
        },
        getCarrierBaseSetting(shippingMethodId, model) {
            let v = this;
            v.carrierBaseSetting = [];
            v.shippingMethodModel = [];
            v.axios.get(api.get_shippingMethodParams + '?shippingMethodId=' + shippingMethodId)
                .then(response => {
                    if (response.data.code === 0) {
                        let data = response.data.datas;
                        data.forEach((n, i) => {
                            if (model) {
                                v[model].push({
                                    paramKey: n.paramKey,
                                    paramValue: n.paramValue
                                });
                            } else {
                                v.shippingMethodModel.push({
                                    paramKey: n.paramKey,
                                    paramValue: n.paramValue
                                });
                            }
                        });
                        v.carrierBaseSetting = data;
                    } else {
                        v.$Message.error(v.t('common.sysErrorMes'));
                    }
                });
        },
        toggleMoreFilter() {
            let v = this;
            if (v.moreFilter) {
                v.moreFilter = false;
                v.moreFilterMes = v.storeFilterMes;
                v.moreFilterIcon = 'chevron-down';
            } else {
                v.moreFilter = true;
                if (v.storeFilterMes === '') {
                    v.storeFilterMes = v.moreFilterMes;
                }
                if ((v.pageParams.searchValue && v.pageParams.searchValue) !== '') {
                    v.pageParams.searchValue = '';
                }
                v.moreFilterMes = '收起';
                v.moreFilterIcon = 'chevron-up';
            }
        },
        modifyTheSort(index, status) {
            let v = this;
            v.pageParams.orderBy = v.buttonGroupModel[index].type;
            v.buttonGroupModel.forEach((n, i) => {
                if (i === index && n.selected) {
                    v.buttonGroupModel[index].status = !v.buttonGroupModel[index].status;
                } else if (i === index && !n.selected) {
                    n.selected = true;
                } else {
                    n.selected = false;
                }
            });
            v.pageParams.upDown = v.buttonGroupModel[index].status ? 'up' : 'down';
            v.pageParamsStatus = true;
        },
        changePage(page) { // 分页切换
            let v = this;
            v.loading = true;
            v.pageParams.pageNum = page;
            v.pageParamsStatus = true;
            v.curPage = page;
        },
        showShippingData(value) {
            if (value) {
                this.getShippingList();
            }
        },
        domResize(fn) {
            let originFn = window.onresize;
            window.onresize = function() {
                originFn && originFn();
                fn();
            };
        },
        resetTag() {
            let v = this;
            v.tagIdList = [];
            v.orderIdList = [];
        },
        dropOrderTag() {
            let v = this;
            if (v.orderIdList.length === 0 || v.orderIdList === null) {
                v.$Message.error(v.t('order.selectOrder'));
                return false;
            }
            v.axios.delete(api.drop_orderTag + '?orderIds=' + v.orderIdList)
                .then(response => {
                    if (response.data.code === 0) {
                        v.$Message.success(v.t('common.clearMakrSuccess'));
                        v.pageParamsStatus = true;
                        v.resetTag();
                    } else {
                        v.$Message.error(v.t('common.sysErrorMes'));
                        v.resetTag();
                    }
                });
        },
        setTag(type) { // 打标签
            let v = this;
            if (v.orderIdList.length === 0) {
                v.$Message.error(v.t('order.selectOrder'));
            } else if (v.tagIdList.length === 0) {
                v.$Message.error(v.t('order.selectTags'));
            } else {
                let obj = {
                    orderIdList: v.orderIdList,
                    tagIdList: v.tagIdList
                };
                v.axios.post(api.set_tag, JSON.stringify(obj))
                    .then(response => {
                        if (response.data.code === 0) {
                            v.$Message.success(v.t('common.markSuccess'));
                            v.resetTag();
                            v.setTagListStatus = false;
                            v.pageParamsStatus = true;
                        } else {
                            v.$Message.error(v.t('common.operateFailMes'));
                        }
                    });
            }
        },
        changePageSize(pageSize, plat) {
            this.pageParams.pageSize = pageSize;
            this.pageParamsStatus = true;
        },
        displayPage(params) {
            if (!params) params = [];
            if (params.length !== 0) {
                this.pageHide = true;
            } else {
                this.pageHide = false;
            }
        },
        gotoError() {
            this.$router.push('noPersermission');
        },
        countryName(code) {
            return new Promise((resolve) => {
                if (localStorage.getItem('area') !== null) { // 匹配国家名字
                    let area = JSON.parse(localStorage.getItem('area'));
                    for (var i = 0; i < area.length; i++) {
                        if (area[i].twoCode === code) {
                            resolve(area[i].enName);
                            break;
                        }
                    }
                }
            });
        },
        getLimitTime(value) {
            let theTime = parseInt(value); // 秒
            let day = 0;
            let theTime1 = 0; // 分
            let theTime2 = 0; // 小时
            if (theTime / 60 / 60 / 24 >= 1) {
                day = parseInt(theTime / 60 / 60 / 24);
                theTime = theTime % (60 * 60 * 24);
                if (theTime / 60 / 60 >= 1) {
                    theTime2 = parseInt(theTime / 60 / 60);
                    theTime = theTime % (60 * 60);
                    if (theTime / 60 >= 1) {
                        theTime1 = parseInt(theTime / 60);
                    }
                }
                return day + 'day ' + theTime2 + 'hour ' + theTime1 + 'min';
            } else if (theTime / 60 / 60 / 24 < 1 && theTime / 60 / 60 >= 1) {
                theTime2 = parseInt(theTime / 60 / 60);
                theTime = theTime % (60 * 60);
                if (theTime / 60 >= 1) {
                    theTime1 = parseInt(theTime / 60);
                }
                return theTime2 + 'hour ' + theTime1 + 'min';
            } else if (theTime / 60 / 60 / 24 < 1 && theTime / 60 / 60 < 1 && theTime / 60 >= 1) {
                theTime1 = parseInt(theTime / 60);
                return theTime1 + 'min';
            } else if (value === 0) {
                return this.t('order.overdue');
            } else {
                return 'Less than a minute';
            }
        },
        getErpConfig() {
            let v = this;
            return new Promise(resolve => {
                v.axios.get(api.get_erpConfig)
                    .then(response => {
                        if (response.data.code === 0) {
                            v.$store.commit('erpConfig', response.data.datas);
                            resolve(true);
                        }
                    });
            });
        },
        getUserName(userId) {
            let v = this;
            let userInfoList = v.$store.state.userInfoList;
            if (userInfoList !== null && userInfoList[userId] !== undefined) {
                return userInfoList[userId].userName;
            } else {
                return '';
            }
        },
        resetLoading(loadingName) { //reset loading common method
            let v = this;
            v[loadingName] = false;
            v.$nextTick(function() {
                v[loadingName] = true;
            })
        },
        getPlatformGroup(status) { // 查看已开启平台
            let v = this;
            if (!status) status = 1;
            return new Promise(resolve => {
                v.axios.get(api.get_queryByStatus + '?status=' + status)
                    .then(response => {
                        if (response.data.code === 0) {
                            v.$store.commit('platformGroup', response.data.datas);
                            resolve(true);
                        }
                    });
            });
        },
        // 错误提示
        showErrorInfoFn(code,message) {
            let v = this;
            // if (code === 20013) {
            //     v.$Message.error({
            //         content: v.t('error.templateDataError'),
            //         duration: 4
            //     });
            // } else if (code === 20014) {
            //     v.$Message.error({
            //         content: v.t('error.templateDataError14'),
            //         duration: 4
            //     });
            // } else if (code === 20015) {
            //     v.$Message.error({
            //         content: v.t('error.templateDataError15'),
            //         duration: 4
            //     });
            // } else if (code === 20016) {
            //     v.$Message.error({
            //         content: v.t('error.templateDataError16'),
            //         duration: 4
            //     });
            // } else if (code === 20017) {
            //     v.$Message.error({
            //         content: v.t('error.templateDataError17'),
            //         duration: 4
            //     });
            // } else if (code === 20018) {
            //     v.$Message.error({
            //         content: v.t('error.templateDataError18'),
            //         duration: 4
            //     });
            // } else if (code === 20019) {
            //     v.$Message.error({
            //         content: v.t('error.templateDataError19'),
            //         duration: 4
            //     });
            // } else if (code === 20020) {
            //     v.$Message.error({
            //         content: v.t('error.templateDataError20'),
            //         duration: 4
            //     });
            // } else if (code === 20021) {
            //     v.$Message.error({
            //         content: v.t('error.templateDataError21'),
            //         duration: 4
            //     });
            // } else if (code === 20022) {
            //     v.$Message.error({
            //         content: v.t('error.templateDataError22'),
            //         duration: 4
            //     });
            // } else if (code === 20023) {
            //     v.$Message.error({
            //         content: v.t('error.templateDataError23'),
            //         duration: 4
            //     });
            // } else if (code === 20024) {
            //     v.$Message.error({
            //         content: v.t('error.templateDataError24'),
            //         duration: 4
            //     });
            // } else if (code === 20025) {
            //     v.$Message.error({
            //         content: v.t('error.templateDataError25'),
            //         duration: 4
            //     });
            // } else if (code === 20026) {
            //     v.$Message.error({
            //         content: v.t('error.templateDataError26'),
            //         duration: 4
            //     });
            // } else if (code === 20027) {
            //     v.$Message.error({
            //         content: v.t('error.templateDataError27'),
            //         duration: 4
            //     });
            // } else if (code === 20028) {
            //     v.$Message.error({
            //         content: v.t('error.templateDataError28'),
            //         duration: 4
            //     });
            // } else if (code === 20029) {
            //     v.$Message.error({
            //         content: v.t('error.templateDataError29'),
            //         duration: 4
            //     });
            // } else if (code === 20030) {
            //     v.$Message.error({
            //         content: v.t('error.templateDataError30'),
            //         duration: 4
            //     });
            // } else if (code === 20031) {
            //     v.$Message.error({
            //         content: v.t('error.templateDataError31'),
            //         duration: 4
            //     });
            // } else if (code === 20032) {
            //     v.$Message.error({
            //         content: v.t('error.templateDataError32'),
            //         duration: 4
            //     });
            // } else if (code === 20033) {
            //     v.$Message.error({
            //         content: v.t('error.templateDataError33'),
            //         duration: 4
            //     });
            // } else if (code === 20034) {
            //     v.$Message.error({
            //         content: v.t('error.templateDataError34'),
            //         duration: 4
            //     });
            // } else if (code === 20035) {
            //     v.$Message.error({
            //         content: v.t('error.templateDataError35'),
            //         duration: 4
            //     });
            // } else if (code === 20036) {
            //     v.$Message.error({
            //         content: v.t('error.templateDataError36'),
            //         duration: 4
            //     });
            // } else if (code === 20037) {
            //     v.$Message.error({
            //         content: v.t('error.templateDataError37'),
            //         duration: 4
            //     });
            // } else if (code === 20038) {
            //     v.$Message.error({
            //         content: v.t('error.templateDataError38'),
            //         duration: 4
            //     });
            // } else if (code === 20039) {
            //     v.$Message.error({
            //         content: v.t('error.importTableError'),
            //         duration: 4
            //     });
            // } else if (code === 20040) {
            //     v.$Message.error({
            //         content: v.t('error.importWayBillNumExists'),
            //         duration: 4
            //     });
            // } else if (code === 20000) {
            //     v.$Message.error({
            //         content: v.t('error.shippingError'),
            //         duration: 4
            //     });
            // } else if (code === 10029) {
            //     v.$Message.error({
            //         content: v.t('error.errorTip10029'),
            //         duration: 4
            //     });
            // } else if (code === 20041) {
            //     v.$Message.error({
            //         content: v.t('error.templateDataError41'),
            //         duration: 4
            //     });
            // } else if (code === 20042) {
            //     v.$Message.error({
            //         content: v.t('error.templateDataError42'),
            //         duration: 4
            //     });
            // } else if (code === 20043) {
            //     v.$Message.error({
            //         content: v.t('error.templateDataError43'),
            //         duration: 4
            //     });
            // } else if (code === 20044) {
            //     v.$Message.error({
            //         content: v.t('error.errorTip20044'),
            //         duration: 4
            //     });
            // } else if (code === 20045) {
            //     v.$Message.error({
            //         content: v.t('error.errorTip20045'),
            //         duration: 4
            //     });
            // } else if (code === 90002) {
            //     v.$Message.error(v.t('error.errorTip90002'));
            // } else if (code === 90003) {
            //     v.$Message.error(v.t('error.errorTip90003'));
            // } else if (code === 90004) {
            //     v.$Message.error("物流商不存在，请等审核通过再试");
            // } else if (code === 10006) {
            //     v.$Message.error(v.t('error.errorTip10006'));
            // } else if (code === 10010) {
            //     v.$Message.error(v.t('error.errorTip10010'));
            // } else if (code === 10011) {
            //     v.$Message.error(v.t('error.errorTip10011'));
            // } else if (code === 10012) {
            //     v.$Message.error(v.t('error.errorTip10012'));
            // } else if (code === 10014) {
            //     v.$Message.error(v.t('error.errorTip10014'));
            // } else if (code === 10015) {
            //     v.$Message.error(v.t('error.errorTip10015'));
            // } else if (code === 10016) {
            //     v.$Message.error(v.t('error.errorTip10016'));
            // } else if (code === 10017) {
            //     v.$Message.error(v.t('error.errorTip10017'));
            // } else if (code === 10018) {
            //     v.$Message.error(v.t('error.errorTip10018'));
            // } else if (code === 10019) {
            //     v.$Message.error(v.t('error.errorTip10019'));
            // } else if (code === 10020) {
            //     v.$Message.error(v.t('error.errorTip10020'));
            // } else if (code === 10021) {
            //     v.$Message.error(v.t('error.errorTip10021'));
            // } else if (code === 10022) {
            //     v.$Message.error(v.t('error.errorTip10022'));
            // } else if (code === 10023) {
            //     v.$Message.error(v.t('error.errorTip10023'));
            // } else if (code === 10024) {
            //     v.$Message.error(v.t('error.errorTip10024'));
            // } else if (code === 10025) {
            //     v.$Message.error(v.t('error.errorTip10025'));
            // } else if (code === 10026) {
            //     v.$Message.error(v.t('error.errorTip10026'));
            // } else if (code === 10027) {
            //     v.$Message.error(v.t('error.errorTip10027'));
            // } else if (code === 10028) {
            //     v.$Message.error(v.t('error.errorTip10028'));
            // } else if (code === 20050) {
            //     v.$Message.error(v.t('error.errorTip20050'));
            // } else if (code === 20051) {
            //     v.$Message.error(v.t('error.errorTip20051'));
            // } else if (code === 20052) {
            //     v.$Message.error(v.t('error.errorTip20052'));
            // } else if (code === 20053) {
            //     v.$Message.error(v.t('error.errorTip20053'));
            // } else if (code === 20054) {
            //     v.$Message.error(v.t('error.errorTip20054'));
            // } else if (code === 20055) {
            //     v.$Message.error(v.t('error.errorTip20055'));
            // } else if (code === 20056) {
            //     v.$Message.error(v.t('error.errorTip20056'));
            // } else if (code === 20057) {
            //     v.$Message.error(v.t('error.errorTip20057'));
            // } else if (code === 20073) {
            //     v.$Message.error(v.t('error.errorTip20073'));
            // } else if (code === 20074) {
            //     v.$Message.error(v.t('error.errorTip20074'));
            // } else if (code === 20075) {
            //     v.$Message.error(v.t('error.errorTip20075'));
            // } else if (code === 20076) {
            //     v.$Message.error(v.t('error.errorTip20076'));
            // } else if (code === 20077) {
            //     v.$Message.error(v.t('error.errorTip20077'));
            // } else if (code === 20078) {
            //     v.$Message.error(v.t('error.errorTip20078'));
            // } else if (code === 20079) {
            //     v.$Message.error(v.t('error.errorTip20079'));
            // } else {
                // v.$Message.error(message);
                v.$Message.error({
                    content: message,
                    duration: 5
                });
            // }
        }
    },
    mounted() {
        let v = this;
        v.domResize(function() {
            v.domWidth = document.documentElement.clientWidth || document.body.clientWidth || 0;
            v.domHeight = document.documentElement.clientHeight || document.body.clientHeight || 0;
        });
    }
};


// WEBPACK FOOTER //
// ./src/components/mixin/common_mixin.js